import script from "./FilePreview_image.vue?vue&type=script&lang=js"
export * from "./FilePreview_image.vue?vue&type=script&lang=js"

import "./FilePreview_image.vue?vue&type=style&index=0&id=be06ce18&lang=scss"

const __exports__ = script;

export default __exports__